<div class="erp-shell" [class.sidebar-collapsed]="sidebarCollapsed()" (click)="closeOverlays()">
  <!-- ======== SIDEBAR ======== -->
  <aside class="erp-sidebar" [class.mobile-open]="mobileSidebarOpen()">
    <!-- Sidebar Brand -->
    <div class="sidebar-brand">
      <div class="brand-logo">
        <!-- <i class="bi bi-mortarboard-fill"></i> -->
         <img src="images/synergy_wlogo.png" height="34">
      </div>
      @if (!sidebarCollapsed()) {
        <div class="brand-text">
          <small class="brand-ver">Ver 1.0</small>
          <span class="brand-name">Synergy</span>
          <span class="brand-sub">Education ERP</span>
        </div>
      }
      <!--<button class="sidebar-toggle-btn d-none d-lg-flex" (click)="$event.stopPropagation(); toggleSidebar()" title="Toggle sidebar">
        <i class="bi" [class.bi-chevron-left]="!sidebarCollapsed()" [class.bi-chevron-right]="sidebarCollapsed()"></i>
      </button>-->
    </div>

    <!-- SidePanel Navigation -->
    <nav class="sidebar-nav">
      <div class="sidebar-erpkey text-light text-center" *ngIf="user.erp_key && !sidebarCollapsed()">
        ERP Key:
        <span id="textToCopy">{{user.erp_key}}</span>&nbsp;
        <i class="bi bi-copy" style="cursor: pointer; font-size: 10px;" title="Copy ERP Key code"
          (click)="copyText('textToCopy')"></i>
      </div>
      <ul class="nav-list mt-2" *ngIf="user">
        @for (item of navItems; track item.route) {
          <li class="nav-item" *ngIf="item.visible && (item.optFor=='BO' || ((user.code=='spr' && item.optFor=='SA') || (user.code!=='spr' && item.optFor=='UR')))">
            <a
              class="nav-link-item"
              [routerLink]="item.route"
              routerLinkActive="active"
              [title]="sidebarCollapsed() ? item.label : ''"
              (click)="mobileSidebarOpen.set(false)"
            >
              <i class="bi {{ item.icon }} nav-icon"></i>
              @if (!sidebarCollapsed()) {
                <span class="nav-label">{{ item.label }}</span>
                @if (item.badge) {
                  <span class="nav-badge badge {{ item.badgeClass ?? 'bg-primary' }}">{{ item.badge }}</span>
                }
              } @else {
                @if (item.badge) {
                  <span class="collapsed-badge"></span>
                }
              }
            </a>
          </li>
        }
      </ul>
    </nav>

    <!-- Sidebar Footer -->
    @if (!sidebarCollapsed()) {
      <div class="sidebar-footer">
        <div class="academic-year-badge">
          <i class="bi bi-calendar2-check me-2"></i>
          Academic Year {{acd_session}}
        </div>
      </div>
    }
  </aside>

  <!-- Mobile Sidebar Overlay -->
  @if (mobileSidebarOpen()) {
    <div class="sidebar-overlay" (click)="mobileSidebarOpen.set(false)"></div>
  }

  <!-- ======== MAIN CONTENT AREA ======== -->
  <div class="erp-main">
    <!-- TOP NAVBAR -->
    <header class="erp-topbar">
      <div class="topbar-left">
        <button class="topbar-btn d-lg-none" (click)="$event.stopPropagation(); toggleMobileSidebar()">
          <i class="bi bi-list fs-5"></i>
        </button>
        <button class="sidebar-toggle-btn d-none d-lg-flex" (click)="$event.stopPropagation(); toggleSidebar()" title="Toggle sidebar">
          <i class="bi" [class.bi-chevron-left]="!sidebarCollapsed()" [class.bi-chevron-right]="sidebarCollapsed()"></i>
        </button>
        <div class="topbar-breadcrumb d-none d-sm-block" *ngIf="sidebarCollapsed()">
          <!-- <i class="bi bi-house me-1 text-muted" style="font-size: 1.5rem;"></i> -->
          <span class="text-muted" style="font-size: 1.5rem;"><b>Synergy</b> 1.0
          {{user.erp_key ? '&nbsp;&nbsp;Key: ' + user.erp_key : ''}}</span>
        </div>
      </div>

      <!-- <div class="topbar-center d-none d-md-flex">
        <div class="topbar-search">
          <i class="bi bi-search search-icon"></i>
          <input type="text" placeholder="Search students, staff, records…" class="search-input">
          <kbd class="search-shortcut">^F</kbd>
        </div>
      </div> -->

      <!-- Expiring Message -->
      <div class="topbar-center blink-text text-center text-danger" *ngIf="reNewAlert">
        <i class="bi bi-hourglass-split"></i>
        Your subscription ends on [{{user.exp_date|date}}]. Re-new it soon to keep your services running.
        <!-- <a [routerLink]="['/dashboard/', dataService.myEncrypt('kyc')]">Re-New!</a> -->
      </div>

      <div class="topbar-right">
        <!-- Clock -->
        <!-- <div class="topbar-clock d-xl-block">
          <i class="bi bi-clock me-1"></i>
          {{ currentTime() | date:'HH:mm:ss' }}
        </div> -->

        <button class="topbar-btn position-relative" title="Menu Settings"
          [routerLink]="['/dashboard/', dataService.myEncrypt('mnus')]" *ngIf="user.code == 'spr'">
          <i class="bi bi-ui-checks-grid fs-5"></i>
        </button>

          <!-- Notifications:  *ngIf="user.code !== 'spr'" -->
        <div class="topbar-action-wrap" (click)="$event.stopPropagation()">
          <div class="d-flex gap-2">
          <button class="topbar-btn position-relative"  data-bs-toggle="offcanvas"
								data-bs-target="#offcanvasCalc" title="Calculator">
            <i class="bi bi-calculator-fill fs-5"></i>
          </button>

          <button class="topbar-btn position-relative" (click)="toggleNotifications()" title="Notifications">
            <i class="bi bi-bell-fill fs-5"></i>
            @if (unreadCount > 0) {
              <span class="notif-dot">{{ unreadCount }}</span>
            }
          </button>
        </div>

          @if (notificationsOpen() && notifications() && notifications()?.length) {
            <div class="dropdown-panel notifications-panel">
              <div class="panel-header">
                <span class="fw-semibold">Notifications</span>
                <button class="btn btn-link btn-sm p-0 text-primary" (click)="markAllRead()">Mark all read</button>
              </div>
              <ul class="notif-list">
                @for (n of notifications(); track n.ntext) {
                  <li class="notif-item" [class.unread]="n?.unread">
                    <div class="notif-icon {{ n?.icon_bg }}">
                      <i class="bi {{ n?.icon }}"></i>
                    </div>
                    <div class="notif-body">
                      <p class="notif-text">{{ n?.ntext }}</p>
                      <span class="notif-time">{{ n?.ntime }}</span>
                    </div>
                    @if (n?.unread) {
                      <span class="unread-dot"></span>
                    }
                  </li>
                }
              </ul>
              <div class="panel-footer">
<!-- 1. Required/Matrix Parameter (URL becomes: /profile/42) -->
<!-- <a [routerLink]="['/profile', userId]">View Profile</a> -->
<!-- 2. Query Parameter (URL becomes: /search?category=books&sort=price) -->
<!-- <a [routerLink]="['/search']" [queryParams]="{ category: 'books', sort: 'price' }">Search Books</a> -->

                <a [routerLink]="['/dashboard/', dataService.myEncrypt('noti')]" class="text-primary small">View all notifications</a>
              </div>
            </div>
          }
        </div>

        <!-- Profile -->
        <div class="topbar-action-wrap" (click)="$event.stopPropagation()">
          <button class="profile-btn" (click)="toggleProfile()">
            <div class="avatar">
              <span>{{dataService.getInitName(user.display_name)}}</span>
            </div>
            <div class="profile-info d-none d-lg-block">
              <span class="profile-name">{{user.display_name}}</span>
              <!--<span class="profile-role">Super Admin</span>-->
            </div>
            <i class="bi bi-chevron-down ms-1 d-none d-lg-block" style="font-size: 0.7rem; color: #6b7280;"></i>
          </button>

          @if (profileOpen()) {
            <div class="dropdown-panel profile-panel">
              <div class="profile-panel-header" data-bs-toggle="dropdown">
                <div class="avatar avatar-lg">
                  <span>{{dataService.getInitName(user.display_name)}}</span>
                </div>
                <div>
                  <p class="fw-semibold mb-0">{{user.display_name}}</p>
                  <span class="badge bg-primary-subtle text-primary small" *ngIf="user.erp_key">{{user.user_role[0].name}} ({{user.erp_key}})</span>
                  <span class="badge bg-primary-subtle text-primary small" *ngIf="!user.erp_key">{{user.user_role[0].name}}</span>
                </div>
              </div>
              <ul class="profile-menu" (click)="toggleProfile();" *ngIf="user.user_role.length > 1">
                @for(r of user.user_role; track r;) {
                <li (click)="changeRole(r);"><span><i class="bi bi-window-stack me-2"></i>Change Role as {{r.name}}</span></li>
                }
                <li class="divider"></li>
              </ul>

              <ul class="profile-menu" (click)="toggleProfile();">
                <li (click)="myProfile();"><span><i class="bi bi-person me-2"></i>My Profile</span></li>
                <li [routerLink]="['/dashboard/', dataService.myEncrypt('dix')]"><span><i class="bi bi-database-down me-2"></i>Data Import / Export</span></li>
                <li [routerLink]="['/dashboard/', dataService.myEncrypt('dir')]"><span><i class="bi bi-telephone me-2"></i>Telephone Directory</span></li>
                <li [routerLink]="['/dashboard/', dataService.myEncrypt('noti')]"><span><i class="bi bi-bell me-2"></i>Notification Manager</span></li>
                <li [routerLink]="['/dashboard/', dataService.myEncrypt('alog')]"><span><i class="bi bi-bell me-2"></i>Activity Log</span></li>
                <li [routerLink]="['/dashboard/', dataService.myEncrypt('cmsg')]" *ngIf="user.code == 'spr'"><span><i class="bi bi-envelope-at me-2"></i>Contact Messages</span></li>
                <li><span><i class="bi bi-gear me-2"></i>Account Settings</span></li>
                <li [routerLink]="['/dashboard/', dataService.myEncrypt('hlp')]"><span><i class="bi bi-headset me-2"></i>Help Desk</span></li>
                <li class="divider"></li>
                <li (click)="logout()">
                  <span class="text-danger"><i class="bi bi-box-arrow-right me-2"></i>Sign Out</span>
                </li>
              </ul>
            </div>
          }
        </div>
      </div>
    </header>

    <!-- PAGE CONTENT -->
    <main class="erp-content">
      @if(subPage) {
        <router-outlet></router-outlet>
      } @else {
      @if(!pg) {
        @if(user.code == 'spr' || user.code == 'adm') {
          @if(!subPage) {
            <app-main></app-main>
          }
        } @else if (user.code == 'std') {
          <!-- <app-std-content></app-std-content> -->
          <app-student-dashboard></app-student-dashboard>
        } @else if (user.code == 'tch') {
          <app-tchr-content></app-tchr-content>
        } @else if (user.code == 'ppl') {
          <app-ppl-content></app-ppl-content>
        } @else if (user.code == 'onr') {
          <app-owner-content></app-owner-content>
        } @else if (user.code == 'hra') {
          <app-hra-content></app-hra-content>
        } @else if (user.code == 'rec') {
          <app-rec-content></app-rec-content>
        } @else if (user.code == 'trp') {
          <app-trp-content></app-trp-content>
        } @else if (user.code == 'con') {
          <app-cons-content></app-cons-content>			
        }
        <!-- <app-chat-widget></app-chat-widget> -->
      } @else {
        <!-- Load Component via Dashboard Menu Boxes -->
        <ng-container *ngComponentOutlet="currentComponent" />

        <!-- Load Component via Parameter -->
        @if(pg == 'kycpay') {
          <app-kyc-payment></app-kyc-payment>
        } @else if(pg == 'ufup') {
          <app-follow-ups></app-follow-ups>
        } @else if(pg == 'clg') {
          <app-eligibility-check></app-eligibility-check>
        } @else if(pg == 'payrec') {
          <app-payment-receipt></app-payment-receipt>
        } @else if(pg == 'profile') {
          <app-my-profile></app-my-profile>
        } @else if(pg == 'noti') {
           <app-notifications></app-notifications>
        } @else if(pg == 'cmsg') {
          <app-contact-messages></app-contact-messages>
        } @else if(pg == 'dix') {
          <main class="container">
            <app-excel-import-export
              [previewRows]="8"
              [pageSize]="8"
              exportFormat="xlsx"
              exportFileName="selected-data"
              (imported)="onImported($event)"
              (exported)="onExported($event)">
            </app-excel-import-export>
          </main>
        }
      }
    }
    </main>
  </div>
</div>

<!-- Modal -->
 <div class="modal fade" id="staticBackdrop1" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
    <div class="modal-content">
      <div class="modal-body p-3" *ngIf="pg=='trial'">
        <app-trial-info></app-trial-info>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="staticBackdrop2" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel2" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
    <div class="modal-content">
      <div class="modal-body p-0" *ngIf="pg=='kyc'">
        <app-kyc-wizard [view]="'client'"></app-kyc-wizard>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="staticBackdrop3" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel3" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
    <div class="modal-content">
      <div class="modal-body p-0">
        <!-- <app-agreement></app-agreement> -->
      </div>
    </div>
  </div>
</div>

<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasCalc" aria-labelledby="offcanvasCalcLabel"
	style="width: 500px;">
	<div class="offcanvas-header">
		<h5 class="offcanvas-title" id="offcanvasCalcLabel">Calculator</h5>
		<button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
	</div>
	<div class="offcanvas-body">
      <app-ledger-calculator></app-ledger-calculator>
	</div>
</div>

<button id="trialModalBtn" data-bs-toggle="modal" data-bs-target="#staticBackdrop1" [hidden]="true"></button>
<button id="kycModalBtn" data-bs-toggle="modal" data-bs-target="#staticBackdrop2" [hidden]="true"></button>
<button id="agmModalBtn" data-bs-toggle="modal" data-bs-target="#staticBackdrop3" [hidden]="true"></button>
